import { render, staticRenderFns } from "./ExpandableSideNav.vue?vue&type=template&id=e1908264&scoped=true"
import script from "./ExpandableSideNav.vue?vue&type=script&lang=js"
export * from "./ExpandableSideNav.vue?vue&type=script&lang=js"
import style0 from "./ExpandableSideNav.vue?vue&type=style&index=0&id=e1908264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1908264",
  null
  
)

export default component.exports